module.exports = __webpack_public_path__ + "img/peru.3a3b530a.svg";